import { render, staticRenderFns } from "./FormValidationFailuresSummary.vue?vue&type=template&id=1dd748a2&scoped=true"
import script from "./FormValidationFailuresSummary.vue?vue&type=script&lang=js"
export * from "./FormValidationFailuresSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd748a2",
  null
  
)

export default component.exports